module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAITgAACE4AUWWMWAAAAAfSURBVDhPY/wPBAxkAiYoTRYY1UwiGNVMIhiSmhkYAG3ABBpVZQb6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/media/blank.png
// module id = 1239
// module chunks = 0